import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { AlertCircleIcon } from '../../components/ui/icons';
import './feedModal.css';

interface ConfirmModalProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  /** Thumbnail of the subject of the confirmation, e.g. the post being deleted. */
  mediaUrl?: string | null;
  loading?: boolean;
  showIcon?: boolean;
}

export function ConfirmModal({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onClose,
  onConfirm,
  mediaUrl = null,
  loading = false,
  showIcon = false,
}: ConfirmModalProps) {
  return (
    <Modal
      title={title}
      onClose={loading ? () => undefined : onClose}
      labelledBy="confirm-modal-title"
      className="feed-prompt-modal"
    >
      <div className="feed-prompt">
        {mediaUrl ? (
          <img className="feed-prompt__media feed-prompt__media--preview" src={mediaUrl} alt="" />
        ) : showIcon ? (
          <span className="feed-prompt__media feed-prompt__media--alert" aria-hidden>
            <AlertCircleIcon size={48} />
          </span>
        ) : null}
        <div className="feed-prompt__copy">
          {/* The dialog is already named by the header heading Modal renders. */}
          <p className="feed-prompt__title" aria-hidden="true">{title}</p>
          <p className="feed-prompt__message">{message}</p>
        </div>
        <div className="feed-prompt__actions">
          <Button variant="ghost" size="md" fullWidth onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button size="md" fullWidth onClick={onConfirm} disabled={loading}>
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
